const {
    find, remove, cloneDeep, last, filter, isEqual,
} = require('lodash');

class ProductFilterController {
    constructor($state, settings, breakpointsService, productFilterService) {
        this.$state = $state;
        this.settings = settings;
        this.breakpointsService = breakpointsService;
        this.productFilterService = productFilterService;
    }

    $onInit() {
        this.openContent = this.$state.params.filterOpen === undefined ? this.settings.filter.showFiltersOpen : this.$state.params.filterOpen;
        this.productFilterService.setupLocationChangeEvent();
        this.updateOptionsLevel(false);
    }

    $onChanges(changes) {
        this.selectedFilters = this.selectedFilters || { filters: [] };
        this.filtersToBeApplied = cloneDeep(this.selectedFilters);
        this.productFilterService.updateAnalytics(this.selectedFilters);
        if (changes.availableFilters && this.availableFilters && this.availableFilters.length > 0) {
            this.clonedAvailableFilters = cloneDeep(this.availableFilters);
            // removed category filter from selected filters object
            this.selectedFiltersWithoutCategory = this.selectedFilters.filters && this.selectedFilters.filters.length > 0 ? filter(this.selectedFilters.filters, selectedFilter => selectedFilter.Key !== 'Category') : [];
            const filterFromState = this.$state.params.openFilter ? find(this.availableFilters, availableFilter => availableFilter.Name === this.$state.params.openFilter) : null;

            if (filterFromState != null) {
                this.setCurrentAvailableFilter(filterFromState);
            } else {
                // made last selection as current filter based on filter param in url
                this.setCurrentAvailableFilter(this.selectedFiltersWithoutCategory.length > 0
                    ? find(this.availableFilters, availableFilter => availableFilter.Name === last(this.selectedFiltersWithoutCategory).Key)
                    : this.availableFilters[0]);
            }
        }
    }

    setCurrentAvailableFilter(currentAvailableFilter) {
        if (this.currentAvailableFilter !== currentAvailableFilter) {
            this.currentAvailableFilter = currentAvailableFilter;
            this.applyFilter();
        }

    }

    onFilterToggled(filterName, filterTerm, applyFilterOnSelection = false) {
        let filterParam = find(this.filtersToBeApplied.filters, { Key: filterName });

        if (!filterParam) {
            filterParam = { Key: filterName, Items: [] };
            this.filtersToBeApplied.filters.push(filterParam);
        }

        const term = find(filterParam.Items, { Term: filterTerm });
        if (!term) {
            filterParam.Items.push({ Term: filterTerm });
        } else {
            remove(filterParam.Items, { Term: filterTerm });
        }

        if (applyFilterOnSelection) {
            this.applyFilter();
        }
    }

    applyFilter() {
        if (!isEqual(this.selectedFilters, this.filtersToBeApplied)) {
            this.selectedFilters = this.filtersToBeApplied;
            this.updateState(this.openContent);
            this.toggleOverlay(false);
        }
    }

    clearAllFilters() {
        this.availableFilters = this.clonedAvailableFilters;
        this.setCurrentAvailableFilter(this.availableFilters[0]);
        this.filtersToBeApplied.filters = [];
        this.toggleOverlay(true);
        this.$state.go('.', { filter: null });
    }

    updateState(filterOpen) {
        this.$state.go('.', {
            filter: this.selectedFilters, filterOpen, pageNumber: undefined, openFilter: this.currentAvailableFilter.Name,
        }, { reload: false });
    }

    toggleOverlay(value) {
        this.showContent = value;
        this.updateOptionsLevel(false);
    }

    updateOptionsLevel(value) {
        this.optionsLevel = value;
    }

    toggleContent() {
        this.openContent = !this.openContent;
        this.updateState(this.openContent);
    }
}

ProductFilterController.$inject = ['$state', 'Settings', 'BreakpointsService', 'ProductFilterService'];

const productFilterComponentDefinition = {
    bindings: {
        availableFilters: '<',
        selectedFilters: '<',
        totalRecordCount: '<',
    },
    controller: ProductFilterController,
    template: require('./product-filter.component.html').trim(),
};

module.exports = {
    ProductFilterController,
    productFilterComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/tiles/filter/product-filter.component.js